import { IconButton, Tooltip } from "@mui/material";
import { PauseCircleFilled, PlayCircleFilledWhite } from "@mui/icons-material";
import * as React from "react";

interface Props {
    onClick: () => void;
    color: "default" | "inherit" | "primary" | "secondary";
    status: PlayStatus;
    controlButtonClass?: string;
    pauseButtonClass?: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    iconHeight?: number;
    iconWidth?: number;
}

export enum PlayStatus {
    Play,
    Paused,
    Stopped,
}

const MicroPlayerControl = (props: Props) => {
    const hoverMessage = props.status === PlayStatus.Play ? "Pause" : "Play";
    const icon =
        props.status === PlayStatus.Play ? (
            <PauseCircleFilled
                style={{ height: props.iconHeight, width: props.iconWidth }}
            />
        ) : (
            <PlayCircleFilledWhite
                style={{
                    height: props.iconHeight,
                    width: props.iconWidth,
                    color: props.disabled ? "#B0B0B0" : undefined,
                }}
            />
        );
    return (
        <Tooltip title={hoverMessage} arrow>
            <span>
                <IconButton
                    sx={{ margin: 0, padding: 1.5, ...props.style }}
                    disabled={props.disabled}
                    onClick={props.onClick}
                    onContextMenu={() => alert("context")}
                    color={props.controlButtonClass ? "inherit" : props.color}
                    size="large"
                >
                    {icon}
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default MicroPlayerControl;
